
export const mixin = {
    install(app) {
        app.config.globalProperties.objectLength = function (object) {
            return Object.keys(object).length;
        };
    },
};
